var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import APIIN from "../../../utils/APIIN";
import { fetchOrdersSuccess, fetchOrdersFailure, FETCH_ORDERS_REQUEST, updateOrdersSuccess, updateOrdersFailure, FETCH_UPDATE_ORDERS_REQUEST, } from "../../actions";
const onFetchOrders = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`/order/list?pageSize=${action.payload.pageSize}&startOffset=${action.payload.startOffset}&scope=${action.payload.scope}&status=${action.payload.status}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
const onUpdateOrders = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.put(`/order/`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchOrdersWorker(action) {
    try {
        const data = yield call(onFetchOrders, action);
        yield put(fetchOrdersSuccess(data));
    }
    catch (error) {
        yield put(fetchOrdersFailure(error));
    }
}
function* updateOrdersWorker(action) {
    var _a;
    try {
        const data = yield call(onUpdateOrders, action);
        yield put(updateOrdersSuccess(data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.messages && ((_a = error.response.data.messages) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            // If error response contains a message, dispatch it
            yield put(updateOrdersFailure(error.response.data.messages[0]));
        }
        else {
            // If not, dispatch a generic error message
            yield put(updateOrdersFailure(error));
        }
    }
}
export function* watchOrdersData() {
    yield takeLatest(FETCH_ORDERS_REQUEST, fetchOrdersWorker);
    yield takeLatest(FETCH_UPDATE_ORDERS_REQUEST, updateOrdersWorker);
}
